import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';
import { FinalContact } from '../components/FinalContact';
const GROUPS = [{
  category: 'Freight, Lanes & Rates',
  items: [{
    q: 'What kind of freight do you get?',
    a: 'For our trucks we deal mostly with dry loads and general freight, mostly food grade. For clients using our dispatch service, it\u2019s your call \u2014 what kind of freight do YOU want to haul?'
  }, {
    q: 'What kinds of lanes?',
    a: 'We run wherever YOU want to. As a general rule we follow the money, based on your profile.'
  }, {
    q: 'Average RPM?',
    a: 'It follows the money, based on your profile and the lanes you want to run.'
  }, {
    q: 'Average per week?',
    a: 'Same answer \u2014 it follows the money, based on your profile and how you run.'
  }, {
    q: 'Fuel surcharge?',
    a: 'Currently all fuel charges are built into most of the loads. However, if there is a separate FS, you will see 100% of it.'
  }, {
    q: 'Where do you find your loads \u2014 relationships or just load boards?',
    a: 'We have relationships directly with brokers, so we get first pick of loads before they hit the general boards. We also use the load boards to great advantage. When someone says \u201Cyou just get loads off the boards, I can do that\u201D \u2014 no you can\u2019t, not like us. We use an integrated AI system to search up to 10 boards at once, hunting for the best loads and helping our dispatchers pick the best ones to go after. That is why our RPM is consistently higher.'
  }]
}, {
  category: 'Pricing, Support & Experience',
  items: [{
    q: 'Help with insurance or registration?',
    a: 'Absolutely. Our sister company, FleetScale Group, can help with everything you might need \u2014 general liability insurance, bobtail insurance, comp & collision insurance, IFTA filing, KYU setup, and more. There is 30 years of trucking experience there. If we don\u2019t know the answer, we know where to get it.'
  }, {
    q: 'Why 7%? Seems high.',
    a: 'You get what you pay for. Sure, you can go to some non-US-based service, pay 3%, and they will do half the job. They don\u2019t have the software we have, and they can\u2019t get rate cons from Highway or RMIS because they don\u2019t have the access we do. We are 100% US-based, nothing outsourced \u2014 with a system built to do 100% of the job securely, with your safety and security in mind all the time.'
  }, {
    q: 'How long have you been in business?',
    a: 'FSG Transport and FleetScale Group have been in Business since January 2026, but the people running it have almost 50 years combined in the trucking industry. We were tired of seeing how the industry was going \u2014 outsiders coming in just to make a dime off the backs of hard-working owner-operators and small fleets. As a retired owner-operator myself, I wanted to build something that does the job right, cares about the owner-operator, and works toward making them successful and happy. That isn\u2019t asking much.'
  }, {
    q: 'How many trucks do you currently dispatch for?',
    a: 'This number changes all the time, up and down. But each dispatcher handles between 5\u20138 trucks. They can do this because of the system we have in place.'
  }]
}, {
  category: 'Payment & Getting Started',
  items: [{
    q: 'How do you handle payment?',
    a: 'As a leased-on driver, you are paid weekly by direct deposit. Clients are billed weekly via ACH or credit card.'
  }, {
    q: 'What do you need from me to get started?',
    a: <div className="space-y-4" data-id="element-484">
            <p data-id="element-485">
              Just click the button below to get to the correct page and start
              your journey to a better life — less stress, no BS.
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-486">
              <Link to="/dispatch-services" className="btn-primary py-2 px-4 text-xs" data-id="element-487">
                Dispatching Services
              </Link>
              <Link to="/lease-on-with-fsg" className="btn-outline-dark py-2 px-4 text-xs" data-id="element-488">
                Lease on with us
              </Link>
            </div>
          </div>
  }]
}];
export function FaqPage() {
  useSeo({
    title: 'FSG Transport FAQ | Dispatch, Lease-On, Broker Setup & Paperwork',
    description: 'Answers to common questions about FSG Transport dispatch services, leasing on, broker setup and security, paperwork, billing, equipment, lanes, and getting started.',
    path: '/faq'
  });
  return <div className="w-full" data-id="element-489">
      <section className="bg-navy text-white pt-36 pb-16 lg:pt-44 lg:pb-20" data-id="element-490">
        <div className="container-custom max-w-3xl" data-id="element-491">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black leading-[1.1] tracking-tight font-['Barlow']" data-id="element-492">
            Frequently Asked Questions
          </h1>
        </div>
      </section>

      <section className="section-padding bg-off-white" data-id="element-493">
        <div className="container-custom max-w-4xl space-y-12" data-id="element-494">
          {GROUPS.map((group, i) => <div key={i} data-id="element-495">
              <h2 className="text-xl font-black text-navy uppercase tracking-wide mb-5 pb-3 border-b-2 border-red font-['Barlow']" data-id="element-496">
                {group.category}
              </h2>
              <div className="space-y-5" data-id="element-497">
                {group.items.map((item, j) => <div key={j} className="bg-white border border-steel rounded-sm p-6" data-id="element-498">
                    <h3 className="font-bold text-navy mb-2" data-id="element-499">{item.q}</h3>
                    <p className="text-body font-medium leading-relaxed" data-id="element-500">
                      {item.a}
                    </p>
                  </div>)}
              </div>
            </div>)}
        </div>
      </section>

      <FinalContact data-id="element-501" />
    </div>;
}